import { render, staticRenderFns } from "./GoogeWalletButton.vue?vue&type=template&id=1ba70d3d&"
import script from "./GoogeWalletButton.vue?vue&type=script&lang=js&"
export * from "./GoogeWalletButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogeWalletButton.vue?vue&type=style&index=0&id=1ba70d3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandLogo: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/BrandLogo.vue').default,CardLoyaltyCodeBar: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/CardLoyaltyCodeBar.vue').default})
